/**
 * «Документы» - модуль переписан: см. ./Documents (API /api/v2/documents, PBAC-доступ).
 * Типы ниже оставлены для старых компонентов (AdminDocumentViewDialog, MarkingCodes).
 */
export { default } from './Documents/DocumentsPage';
export type { DocumentListItem, DocumentDetails } from './Documents/legacyTypes';
